import React, { useState, useEffect } from "react";
import {
  Modal, Box, IconButton, Button, TextField,
  CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TEAL, TEAL_LIGHT, modalStyle } from "../constants";
import { BootstrapButton } from "./BootstrapButton";

export default function AddLineModal({ open, onClose, onSubmit, ctx, isLoading }) {
  const [desc, setDesc] = useState("");
  const [level, setLevel] = useState("category");

  useEffect(() => {
    if (open) {
      setDesc("");
      setLevel(ctx?.level || "category");
    }
  }, [open, ctx]);

  const handleSubmit = () => {
    if (!desc.trim()) return;
    onSubmit({ desc: desc.trim(), level, ctx });
  };

  const title = ctx?.position === "above"
    ? `Sisipkan di Atas "${ctx?.anchorLine?.reportingline_desc?.trim()}"`
    : ctx?.position === "below"
      ? `Sisipkan di Bawah "${ctx?.anchorLine?.reportingline_desc?.trim()}"`
      : "Tambah Baris Baru";

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...modalStyle, width: 520, p: 3.5 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
          <h3 style={{ margin: 0, fontSize: 15 }}>{title}</h3>
          <IconButton size="small" onClick={onClose}><CloseIcon /></IconButton>
        </div>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 2 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Level</InputLabel>
            <Select
              value={level}
              label="Level"
              onChange={(e) => setLevel(e.target.value)}
            >
              <MenuItem value="category">Category</MenuItem>
              <MenuItem value="brand">Brand</MenuItem>
              <MenuItem value="product">Product</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <TextField
          label="Reportingline"
          fullWidth
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          sx={{ mb: 2 }}
          placeholder="contoh: Adem Sari"
          autoFocus
          size="small"
        />

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button variant="outlined" onClick={onClose}
            sx={{ textTransform: "none", color: "#999", borderColor: "#ddd" }}>
            Batal
          </Button>
          <BootstrapButton onClick={handleSubmit} disabled={isLoading || !desc.trim()} sx={{ minWidth: 100 }}>
            {isLoading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : "Tambah"}
          </BootstrapButton>
        </div>
      </Box>
    </Modal>
  );
}